/* unplugin-vue-components disabled */import { render } from "./page-warn.vue?vue&type=template&id=45b8863c"
import script from "./page-warn.vue?vue&type=script&lang=js"
export * from "./page-warn.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__